export default __webpack_public_path__ + "f7f92822dca6c6800ebab0cac1a0f586.svg";